import clsx from 'clsx';
import { CSSProperties, FC, MouseEvent, ReactNode } from 'react';

import './button.scss';

type Props = {
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  onContextMenu?: (e: MouseEvent<HTMLElement>) => void;
  className?: string;
  ariaLabel?: string;
  href?: string;
  target?: string;
  inlineStyles?: CSSProperties;
  disabled?: boolean;
};

const Button: FC<Props> = ({
  children,
  className,
  onClick,
  onContextMenu,
  ariaLabel,
  href,
  target,
  inlineStyles,
  disabled,
}) => {
  if (href) {
    return (
      <a
        href={href}
        className={clsx('button', className, { 'button--disabled': disabled })}
        aria-label={ariaLabel}
        onClick={onClick}
        onContextMenu={onContextMenu}
        target={target}
        style={inlineStyles}
        tabIndex={disabled ? -1 : 0}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={clsx('button', className, { 'button--disabled': disabled })}
      onClick={onClick}
      onContextMenu={onContextMenu}
      aria-label={ariaLabel}
      style={inlineStyles}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
